module.exports = __webpack_public_path__ + "static/media/project2.5423014a.jpg";